import { useState, useEffect, useRef } from "react";
import { message, Spin, Tabs, Modal, Pagination, Input } from "antd";
import {
  add_icon,
  edit_icon,
  calender_icon,
  calender_outlined_icon,
  events_white_icon,
  right_arrow_icon,
  delete_icon,
  calendar_stack_icon,
  plus_white_icon
} from "../../assets/icons/icons";
import {
  Container,
  EventBanner,
  EventDrawer,
  ThemeButton,
  ThemeTable,
} from "../../components/components";
import { NavLink, useSearchParams, useNavigate } from "react-router-dom";
import {
  useAddEventsMutation,
  usePutEventsMutation,
  useLazyGetEventsQuery,
  useDeleteEventMutation,
  useRequestDeleteEventCodeMutation,
} from "../../services/events";
import dayjs from "dayjs";
import { BASE_URL } from "../../constants/constants";
import { getValueFromStorage } from "../../helpers/helpers";

const Event = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(
    searchParams.get("tab") || "1"
  );

  //States
  const [open, setOpen] = useState(false);
  const [resetForm, setResetForm] = useState(false);
  const [editID, setEditID] = useState("");
  const [mode, setMode] = useState("create");
  const [ongoingEvents, setOngoingEvents] = useState([]);
  const [upcomingEvents, setupcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);
  const [authCode, setAuthCode] = useState("");
  const [deleteCodeMessage, setDeleteCodeMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    banner: "",
    start_date: "",
    end_date: "",
    location: "",
    discussion: "",
    speakers: "",
    meetings: "",
    networking_hours: "",
    booths: "",
    description: "",
    event_hall: "",
    eventType: "test",
    numberOfDays: 2,
    scope: "",
    region: "",
  });
  const [image, setImage] = useState("");
  const [ongoingEventsTotal, setOngoingEventsTotal] = useState(0);
  const [upcomingEventsTotal, setupcomingEventsTotal] = useState(0);
  const [pastEventsTotal, setPastEventsTotal] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const resultPerPage = 10;

  //Mutations
  const [getEvents, { isLoading }] = useLazyGetEventsQuery({ currentPage, resultPerPage });
  const [addEvent, { isLoading: addingEvent }] = useAddEventsMutation();
  const [putEvents, { isLoading: updatingEvent }] = usePutEventsMutation();
  const [deleteEvent, { isLoading: deleteLoagding }] = useDeleteEventMutation();
  const [requestDeleteEventCode, { isLoading: requestingDeleteCode }] =
    useRequestDeleteEventCodeMutation();

  useEffect(() => {
    fetchEvents();
  }, [selectedKey, currentPage, resultPerPage]);

  //Fetching Events

  const fetchEvents = async () => {
    let ongoing = selectedKey === "1" ? true : "";
    let upcoming = selectedKey === "2" ? true : "";
    let past = selectedKey === "3" ? true : "";

    try {
      const response = await getEvents({ ongoing, upcoming, past, currentPage, resultPerPage });

      console.log("res", response);
      const eventsData = response?.data?.events?.data || [];
      const totalCount = response?.data?.events?.total || 0;

      if (selectedKey === "1") {
        setOngoingEvents(eventsData);
        setOngoingEventsTotal(totalCount);
      } else if (selectedKey === "2") {
        setupcomingEvents(eventsData);
        setupcomingEventsTotal(totalCount);
      } else if (selectedKey === "3") {
        setPastEvents(eventsData);
        setPastEventsTotal(totalCount);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  // const fetchEvents = async () => {
  //   let ongoing = selectedKey === "1" || "";
  //   let upcoming = selectedKey === "2" || "";
  //   let past = selectedKey === "3" || "";
  //   const response = await getEvents({ ongoing, upcoming, past });
  //   console.log("res", response);
  //   selectedKey === "1"
  //     ? setOngoingEvents(response?.data?.events?.data)
  //     : selectedKey === "2"
  //       ? setupcomingEvents(response?.data?.events?.data)
  //       : selectedKey === "3" && setPastEvents(response?.data?.events?.data);
  // };


  const getTotalEvents = () => {
    if (selectedKey === "1") return ongoingEventsTotal;
    if (selectedKey === "2") return upcomingEventsTotal;
    if (selectedKey === "3") return pastEventsTotal;
    return 0;
  };

  console.log("Ongoing Events Total===>", ongoingEventsTotal)
  console.log("Upcommig Events Total===>", upcomingEventsTotal)
  console.log("Past Events Total===>", pastEventsTotal)



  //Modal Onclose handler
  const onClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      banner: "",
      start_date: "",
      end_date: "",
      location: "",
      discussion: "",
      speakers: "",
      meetings: "",
      networking_hours: "",
      booths: "",
      description: "",
      event_hall: "",
      eventType: "test",
      numberOfDays: 2,
      scope: "",
      region: "",
    });
    setImage("");
    setMode("create");
  };
  const formRef = useRef();
  console.log("Data======>", ongoingEvents)


  const handleEvent = async (FieldsData) => {
    console.log(FieldsData, "FieldsData");

    // Prepare data for sending
    const formatDate = (date) => {
      if (!date) return null;
      return new Date(date).toISOString();
    };

    const data = {
      name: FieldsData.eventName,
      banner: FieldsData.banner,
      start_date: formatDate(FieldsData.start_date),
      end_date: formatDate(FieldsData.end_date),
      location: FieldsData.location,
      discussion: FieldsData.discussion,
      speakers: FieldsData.speakers,
      meetings: FieldsData.meetings,
      networking_hours: FieldsData.networking_hours,
      booths: FieldsData.booths,
      description: FieldsData.description,
      event_hall: FieldsData.event_hall,
      eventType: FieldsData.eventType,
      numberOfDays: FieldsData.numberOfDays ?? 2,
      scope: FieldsData.scope || "",
      region: FieldsData.region || "",
    };

    console.log("Formatted data", data);

    let response;
    try {
      if (mode === "create") {
        response = await addEvent(data);
        if (response?.data?.status === 200) {
          message.success("Event Created Successfully");

          onClose();
          setResetForm(true);
          fetchEvents();

          setTimeout(() => {
            setResetForm(false);
          }, 2000);
        } else {
          message.error(response?.data?.message || "Error creating event");
        }
      } else if (mode === "edit") {
        response = await putEvents({ id: editID, body: data });
        if (response?.data?.status === 200) {
          message.success("Event Updated Successfully");

          onClose();
          setResetForm(true);

          fetchEvents();

          setTimeout(() => {
            setResetForm(false);
          }, 2000);
        } else {
          message.error(response?.data?.message || "Error updating event");
        }
      }
    } catch (error) {
      console.error("Request failed", error);
      message.error("An unexpected error occurred");
    }
  };

  const onEdit = (data) => {
    setEditID(data._id);
    setFormData({
      name: data?.name,
      banner: data?.banner,
      start_date: dayjs(data?.start_date),
      end_date: dayjs(data?.end_date),
      location: data?.location,
      discussion: data?.discussion,
      speakers: data?.speakers,
      meetings: data?.meetings,
      networking_hours: data?.networking_hours,
      booths: data?.booths,
      description: data?.description,
      event_hall: data.event_hall,
      eventType: data.eventType || "test",
      numberOfDays: data?.numberOfDays ?? 2,
      scope: data?.scope || "",
      region: data?.region || "",
    });
    setImage(data?.banner);
    setMode("edit");
    setOpen(true);
  };

  const showDeleteConfirm = async (event) => {
    setEventToDelete(event);
    setAuthCode("");
    setDeleteCodeMessage("");
    setDeleteModalVisible(true);
    try {
      const res = await requestDeleteEventCode(event._id).unwrap();
      setDeleteCodeMessage(
        res?.message ||
          "Auth code has been sent to the admin email and is valid for 30 seconds."
      );
    } catch (error) {
      console.error("Failed to request delete code", error);
      message.error(
        error?.data?.message ||
          "Failed to request delete authorization code. Please try again."
      );
      setDeleteModalVisible(false);
      setEventToDelete(null);
    }
  };

  const handleDeleteConfirm = async () => {
    if (eventToDelete) {
      try {
        if (!authCode) {
          message.warning("Please enter the auth code sent to admin email.");
          return;
        }
        const response = await deleteEvent({
          id: eventToDelete._id,
          authCode,
        });
        if (response?.data?.status === 200) {
          message.success("Event Deleted Successfully");
          fetchEvents();
          setDeleteModalVisible(false);
          setEventToDelete(null);
          setAuthCode("");
        } else {
          message.error(response?.data?.message || "Error deleting event");
        }
      } catch (error) {
        console.error("Delete request failed", error);
        message.error("An unexpected error occurred while deleting the event");
      }
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setEventToDelete(null);
    setAuthCode("");
  };

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: "10%",
      render: (item, record, index) => (
        <p className="text-center font-medium">{index + 1}</p>
      ),
    },
    {
      title: "Banner",
      dataIndex: "banner",
      key: "banner",
      widthL: "20%",
      render: (text) => (
        <div className="flex justify-center">
          <img src={text} alt="" width={45} />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <p className="text-center font-medium">{text}</p>,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      render: (text) => (
        <NavLink to={`/event/${text}`} className="flex justify-center">
          <p className="text-center font-medium">
            {new Date(text).toDateString()}
          </p>
        </NavLink>
      ),
    },
    {
      title: "In Action",
      dataIndex: "_id",
      key: "_id",
      width: "15%",
      render: (text, data) => (
        <span className="flex justify-center items-center z-10">
          <span
            className="mx-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(data);
            }}
          >
            <img src={edit_icon} alt="" width={15} />
          </span>
          <span
            className="mx-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              showDeleteConfirm(data);
            }}
          >
            <img src={delete_icon} alt="" width={15} />
          </span>
        </span>
      ),
    },
    {
      title: "",
      dataIndex: "_id",
      key: "_id",
      width: "8%",
      render: (text) => (
        <NavLink to={`/event/${text}`} className="flex justify-center">
          <img src={right_arrow_icon} alt="" width={15} />
        </NavLink>
      ),
    },
  ];

  const onChange = (key) => {
    setSearchParams({ tab: key });
    setSelectedKey(key);
  };

  // const items = [
  //   {
  //     key: "1",
  //     label: (
  //       <p className={`${selectedKey === "1" ? "font-semibold" : ""}`}>
  //         Ongoing Events
  //       </p>
  //     ),
  //     children: selectedKey === "1" && (
  //       <EventBanner
  //         data={ongoingEvents}
  //         loader={isLoading}
  //         onEdit={onEdit}
  //         showDeleteConfirm={showDeleteConfirm}
  //       />
  //     ),
  //   },
  //   {
  //     key: "2",
  //     label: (
  //       <p className={`${selectedKey === "2" ? "font-semibold" : ""}`}>
  //         Upcoming Events
  //       </p>
  //     ),
  //     children: selectedKey === "2" && (
  //       <EventBanner
  //         data={upcomingEvents}
  //         loader={isLoading}
  //         onEdit={onEdit}
  //         showDeleteConfirm={showDeleteConfirm}
  //       />
  //     ),
  //   },
  //   {
  //     key: "3",
  //     label: (
  //       <p className={`${selectedKey === "3" ? "font-semibold" : ""}`}>
  //         Past Events
  //       </p>
  //     ),
  //     children: selectedKey === "3" && (
  //       <EventBanner
  //         data={pastEvents}
  //         loader={isLoading}
  //         onEdit={onEdit}
  //         showDeleteConfirm={showDeleteConfirm}
  //       />
  //     ),
  //   },
  // ];

  const items = [
    {
      key: "1",
      label: (
        <p className={`${selectedKey === "1" ? "font-semibold" : ""}`}>
          Ongoing Events
        </p>
      ),
      children: (
        <EventBanner
          setCurrentPage={setCurrentPage}
          data={ongoingEvents}
          loader={isLoading}
          onEdit={onEdit}
          showDeleteConfirm={showDeleteConfirm}
        />
      ),
    },
    {
      key: "2",
      label: (
        <p className={`${selectedKey === "2" ? "font-semibold" : ""}`}>
          Upcoming Events
        </p>
      ),
      children: (
        <EventBanner
          setCurrentPage={setCurrentPage}
          data={upcomingEvents}
          loader={isLoading}
          onEdit={onEdit}
          showDeleteConfirm={showDeleteConfirm}
        />
      ),
    },
    {
      key: "3",
      label: (
        <p className={`${selectedKey === "3" ? "font-semibold" : ""}`}>
          Past Events
        </p>
      ),
      children: (
        <EventBanner
          setCurrentPage={setCurrentPage}
          data={pastEvents}
          loader={isLoading}
          onEdit={onEdit}
          showDeleteConfirm={showDeleteConfirm}
        />
      ),
    },
  ];
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  return (
    <Container
      selected={"2"}
      header={
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="bg-primary h-9 w-9 rounded-full flex justify-center items-center">
              <img src={events_white_icon} width={17} height={17} alt="" />
            </div>
            <p className="ml-2 font-semibold text-3xl text-[#42572A]">Events</p>
          </div>
          <div className="flex">
            <ThemeButton
              onClick={() => setOpen(true)}
              className={"h-[45px]"}
              content={
                <div className="flex justify-between items-center gap-4">
                  <img src={calendar_stack_icon} alt="icon" width={18} height={18} />
                  <p>Add Event</p>
                  <img src={plus_white_icon} alt="icon" width={18} height={18} />
                </div>
              }
            />
          </div>
        </div>
      }
    >
      <EventDrawer
        formData={formData}
        image={image}
        setImage={(e) => setImage(e)}
        setFormData={(e) => setFormData(e)}
        isLoading={addingEvent}
        onSubmit={handleEvent}
        open={open}
        onClose={onClose}
        btnTxt={mode == "create" ? "Add Event" : "Edit Event"}
        addIcon
        resetForm={resetForm}
      />
      {/* {isLoading ? (
        <div
          className="flex justify-center items-center"
          style={{ height: "75vh" }}
        >
          <Spin size="large" />
        </div>
      ) : ( */}
      {/* <Tabs
        defaultActiveKey={searchParams.get("tab") || "1"}
        items={items}
        onChange={onChange}
      /> */}

      <Tabs
        defaultActiveKey={searchParams.get("tab") || "1"}
        activeKey={selectedKey}
        onChange={(key) => setSelectedKey(key)}
        items={items}
      />
      <Pagination
        current={currentPage}
        pageSize={resultPerPage}
        total={getTotalEvents()}
        onChange={handlePageChange}
        showSizeChanger={false}
      />
      {/* )} */}
      <Modal
        title="Confirm Delete"
        open={deleteModalVisible}
        onCancel={handleDeleteCancel}
        footer={null}
        closable={!requestingDeleteCode}
        maskClosable={!requestingDeleteCode}
      >
        {requestingDeleteCode ? (
          <div className="flex flex-col justify-center items-center py-6">
            <Spin size="large" />
            <p className="mt-3 text-gray-600">
              Sending authorization code to admin email...
            </p>
          </div>
        ) : (
          <>
            <p className="mb-2">
              {deleteCodeMessage ||
                "Enter the auth code sent to the admin email to delete this event. The code is valid for 30 seconds."}
            </p>
            <Input
              placeholder="Enter 6-digit auth code"
              maxLength={6}
              value={authCode}
              onChange={(e) => setAuthCode(e.target.value)}
            />
            <div className="flex justify-end items-center mt-4 gap-2">
              <ThemeButton
                onClick={handleDeleteCancel}
                className={"ml-3"}
                content={"Cancel"}
              />
              <ThemeButton
                onClick={handleDeleteConfirm}
                className={"ml-3"}
                content={deleteLoagding ? <Spin size="small" /> : "Confirm Delete"}
              />
            </div>
          </>
        )}
      </Modal>
    </Container>
  );
};

export default Event;
